import Grid from "@mui/material/Grid";
import { forwardRef } from "react";

const SlideSectionWrapper = forwardRef(({ children, size }, ref) => {
  return (
    <Grid
      container
      size={size || 12}
      rowSpacing={1}
      columnSpacing={2}
      ref={ref}
    >
      {children}
    </Grid>
  );
});

export default SlideSectionWrapper;
